import React from "react";

import ConfirmationPopup, { DIALOG_TYPES } from "@components/ConfirmationPopup";

import { useFullScreenPopup } from "./useFullScreenPopup";

export const WPFullScreenPopup = () => {
  const { fullScreenData, hideFullScreenPopup } = useFullScreenPopup();

  if (!fullScreenData) {
    return null;
  }
  const { header, description, confirmBtn, cancelBtn, type, props } = fullScreenData;

  /**
   * Handles the closing of the full screen error popup.
   * Calls hideFullScreenPopup with the actionType which will trigger the stored callback
   */
  const handleConfirmationPopupClose = actionType => hideFullScreenPopup(actionType, props || null);

  return (
    <ConfirmationPopup
      onClose={handleConfirmationPopupClose}
      type={type ?? DIALOG_TYPES.ERROR}
      header={header}
      description={description}
      confirmBtn={confirmBtn}
      cancelBtn={cancelBtn}
    />
  );
};
